/**
 * @author       yewon@zumper.com (Yewon Lee)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  switchSetting based on the current env
 */

import { IS_LOCAL_DEV, IS_PRODUCTION } from '@zcode/env'

export const switchSetting = (
  prodDefaultValue: any,
  pokeDefaultValue: any,
  localDefaultValue: any
) => {
  if (IS_PRODUCTION) {
    return prodDefaultValue
  } else if (IS_LOCAL_DEV) {
    return localDefaultValue
  } else {
    return pokeDefaultValue
  }
}
